export default "__VITE_ASSET__BwLlL87P__"